import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Simulator from './RulesPage/components/Simulator/Simulator';
import NoActiveProject from '../components/NoActiveProject';

/**
 * SimulatorPage - Full-page rule simulator under Product.
 */
export default function SimulatorPage() {
    const [searchParams] = useSearchParams();
    const familyId = searchParams.get('familyId') || '';
    const [activeProjectId, setActiveProjectId] = useState(localStorage.getItem('activeProjectId') || '');

    useEffect(() => {
        const handleGlobalProjectChange = () => {
            setActiveProjectId(localStorage.getItem('activeProjectId') || '');
        };
        window.addEventListener('activeProjectChanged', handleGlobalProjectChange);
        return () => window.removeEventListener('activeProjectChanged', handleGlobalProjectChange);
    }, []);

    if (!activeProjectId) {
        return (
            <NoActiveProject description="To simulate a family, select an active project in the header, or create one from the project menu." />
        );
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', overflow: 'hidden', minHeight: 0, padding: '1rem 1.25rem', boxSizing: 'border-box' }}>
            <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                <Simulator initialFamilyId={familyId} />
            </div>
        </div>
    );
}
